/**
 * @generated SignedSource<<42525127cae921122157b084d1c64ec3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsBioModalLazy_seller$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDealerDetailsBioModalLazy_seller";
};
export type PdpSharedDealerDetailsBioModalLazy_seller$key = {
  readonly " $data"?: PdpSharedDealerDetailsBioModalLazy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsBioModalLazy_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "633d304f8e7ed78f4cd822eb85272461";

export default node;
